import styled from 'styled-components/macro';

export const SectionWrapper = styled.section`
    display: flex;
    align-items: center;
    height: 100vh;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 450px;
    padding: 70px 30px 40px;
    margin: 0px auto;
`;

export const Title = styled.h1`
    font-size: 48px;
    font-weight: 600;
    line-height: 1.2;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
`;

export const FormLabel = styled.label`
    font-size: 20px;
    font-weight: 500;
    margin: 45px 0 10px; 
`;

interface InputProps {
    isError: boolean;
}

export const Input = styled.input<InputProps>`
    font-size: 16px;
    color: #495057;
    height: 38px;
    padding: 6px 12px;
    border: 1px solid ${({ isError }) => (isError ? '#F00' : '#ced4da')};
    border-radius: 10px;
    margin-bottom: 15px;

    &:focus {
        border-color: ${({ isError }) => (!isError && '#80bdff')} ;
    }
`;

export const ForgotYourPasswordLink = styled.button`
    color: #989898;

    &:hover {
        color: #0056b3;
        text-decoration: underline;
    }
`;

interface CredentialsErrorContainerProps {
    showErrorMsg: boolean
}

export const CredentialsErrorContainer = styled.div<CredentialsErrorContainerProps>`
    transition: height 0.5s;
    height: ${({ showErrorMsg }) => (showErrorMsg ? '45px' : 0)};
`;

export const CredentialsErrorMessage = styled.span`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #721c24;
    background-color: #f8d7da;
    padding: 5px 10px;
    border-radius: 8px;
    margin-bottom: 10px;
    font-size: 13px;

    ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
        font-size: 16px;
    }
`;

export const SignUpLink = styled.button`
    font-size: 16px;
    color: #007bff;

    &:hover {
        text-decoration: underline;
    }
`;

export const Button = styled.button`
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: #ff0000;
    height: 38px;
    padding: 4px 12.5px;
    border-radius: 10px;
    transition: all 0.4s ease 0s;

    &:hover {
        background-color: #e02020;
    }
`;
